import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, TextFieldWithLabel, Typography } from 'shared/ui'
import { makeTextFieldLoading } from 'shared/ui/TextField'
import { type VerifyNumberStore } from 'pages/settings/ui/VerifyNumberCommon/store/VerifyNumberStore'
import styles from './styles.module.scss'

export const VerifyNumberCode = observer(({ store }: { store: VerifyNumberStore }) => {
  const { verificationCode, initTimer, secondsTime, onResendNewCode, nextLoading, showRetry } =
    store

  useEffect(() => {
    initTimer()
  }, [])

  return (
    <>
      <Box display='flex' justifyContent='space-between' gap={'12px'}>
        <TextFieldWithLabel
          labelProps={{
            label: {
              text: '6-digit code',
            },
          }}
          errorMessage={''}
          textFieldProps={{
            value: verificationCode,
          }}
          rightActions={[
            makeTextFieldLoading({
              loading: nextLoading,
            }),
          ]}
        />
      </Box>

      <div className={styles.textBottomWrap}>
        <Typography
          tag={'div'}
          color='tertiary'
          variant='body-md-regular'
          ariaLabel='VerifyNumberCodeTimeText'
        >
          {!showRetry && <>Haven’t received it? Resend again in {secondsTime}</>}
          {showRetry && (
            <>
              Haven’t received it?{' '}
              <Typography
                tag={'a'}
                variant='body-md-medium'
                className={styles.link}
                ariaLabel={'newCode'}
                onClick={onResendNewCode}
              >
                Resend new code
              </Typography>
            </>
          )}
        </Typography>
      </div>
    </>
  )
})
